import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { Message } from '@domain/models';

@Component({
  selector: 'app-payment-result-not-found',
  templateUrl: './payment-result-not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentNotFoundResultComponent {
  readonly message = input.required<Message>();
  readonly manualValidationRequested = output<Message>();
  readonly requestSent = signal(false);

  requestManualValidation(): void {
    const message = this.message();
    if (message.paymentRetryStatus !== 'AVAILABLE') return;
    this.requestSent.set(true);
    this.manualValidationRequested.emit(message);
  }
}
